import React from "react";
import { Link } from "react-router-dom";
import { FiInfo } from "react-icons/fi";
import styles from "../../style/home.module.css";
import { WHAT_I_DO_LEAD } from "../../data/seoMeta";

const HERO_CONTENT = {
  title: "Hi, I'm Nadine!",
  buttonTo: "/about",
  buttonLabel: "About me",
};

const HeroSection = () => {
  return (
    <div className="container page-shell pt-3 pt-md-5">
      <div className="row align-items-end g-4">
        <div className="col-md-7">
          <h1>{HERO_CONTENT.title}</h1>
          <p className="mb-4">
            {WHAT_I_DO_LEAD} I connect user needs, market insights, and
            information architecture to responsive{" "}
            <b>React and Next.js</b> products. I design in <b>Figma</b>,
            build with reusable components, and focus on clean,
            high-fidelity UI.
          </p>
        </div>
        <div className="col-md-5 text-md-end text-start">
          <Link
            to={HERO_CONTENT.buttonTo}
            className={`${styles.homeButton} btn btn-light w-sm-100 d-inline-flex align-items-center justify-content-center gap-2`}
          >
            <FiInfo aria-hidden="true" />
            {HERO_CONTENT.buttonLabel}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
